import { render, staticRenderFns } from "./MessagesInput.vue?vue&type=template&id=481f5a58&"
import script from "./MessagesInput.vue?vue&type=script&lang=ts&"
export * from "./MessagesInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports